export default "__VITE_ASSET__BFzW8Vo3__"